import {Observable} from 'rxjs';
import {CpmCCustomerApiModel} from '../../models/c-common/cpmc-customer.api-model';
import {
    CpmCCustomerCreateApiSchema,
    CpmCCustomerUpdateApiSchema
} from '../../schemas/c-common/cpmc-customer.api-schemas';
import {CpmCApiBridge} from '../../../../../src/app/cpmc-api-bridge';
import {CpmCQueryPaginatorConfig, CpmCQueryPaginatorConfigUtils} from '../../cpmc-defines';
import {AllowedQueryParamTypes, QueryParams} from '../../../../../sdk/src/utils/query.utils';
import {CpmCPaginatedResultAPISchema} from '../../schemas/cpmc-paginated-result.api-schemas';

export type CpmCGetCustomerListParams = {
    [K in keyof CpmCCustomerApiModel]?: CpmCCustomerApiModel[K] extends AllowedQueryParamTypes
        ? CpmCCustomerApiModel[K]
        : never;
} & {} & QueryParams;

/**
 * Customer Api Service
 */
export class CpmCCustomerApiService {
    public static readonly dPaginatorConfig: CpmCQueryPaginatorConfig = {limit: -1, sort: 'name', order: 1};

    // ===============================================================
    // ===============================================================

    public static baseUrl() {
        return CpmCApiBridge.getBackendBaseURL() + 'api/core/v1/customer';
    }

    // ===============================================================
    // ===============================================================

    public static endpointList(): string {
        return `${CpmCCustomerApiService.baseUrl()}/list`;
    }
    public static endpointNew(): string {
        return `${CpmCCustomerApiService.baseUrl()}`;
    }
    public static endpointGet(customerUUID: string): string {
        return `${CpmCCustomerApiService.baseUrl()}/${customerUUID}`;
    }
    public static endpointEdit(customerUUID: string): string {
        return `${CpmCCustomerApiService.baseUrl()}/${customerUUID}`;
    }
    public static endpointDelete(customerUUID: string): string {
        return `${CpmCCustomerApiService.baseUrl()}/${customerUUID}`;
    }

    // ===============================================================
    // ===============================================================

    public static getCustomerList(
        params: CpmCGetCustomerListParams = {},
        paginatorConfig: CpmCQueryPaginatorConfig = CpmCCustomerApiService.dPaginatorConfig
    ): Observable<CpmCPaginatedResultAPISchema<CpmCCustomerApiModel>> {
        return CpmCApiBridge.httpGet<CpmCPaginatedResultAPISchema<CpmCCustomerApiModel>>(
            CpmCCustomerApiService.endpointList(),
            {
                ...(params as QueryParams),
                ...CpmCQueryPaginatorConfigUtils.toQueryParams(paginatorConfig)
            }
        );
    }
    public static getCustomerByUUID(customerUUID: string): Observable<CpmCCustomerApiModel> {
        return CpmCApiBridge.httpGet<CpmCCustomerApiModel>(CpmCCustomerApiService.endpointGet(customerUUID));
    }
    public static createCustomer(payload: CpmCCustomerCreateApiSchema): Observable<CpmCCustomerApiModel> {
        return CpmCApiBridge.httpPost<CpmCCustomerApiModel>(CpmCCustomerApiService.endpointNew(), payload);
    }
    public static updateCustomer(
        customerUUID: string,
        payload: CpmCCustomerUpdateApiSchema
    ): Observable<CpmCCustomerApiModel> {
        return CpmCApiBridge.httpPut<CpmCCustomerApiModel>(CpmCCustomerApiService.endpointEdit(customerUUID), payload);
    }
    public static deleteCustomer(customerUUID: string): Observable<boolean> {
        return CpmCApiBridge.httpDelete<boolean>(CpmCCustomerApiService.endpointDelete(customerUUID));
    }
}
